var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container",class:{ overlay: _vm.isOverlay }},[_c('div',{staticClass:"spinner",style:({ 
      width: `${_vm.size}px`, 
      height: `${_vm.size}px`,
      borderColor: `${_vm.color} transparent transparent transparent` 
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }